module.exports = __webpack_public_path__ + "img/black-color.edc05f81.svg";